import {
  apiClient,
} from "./apiClient";

import type {
  CancelPurchaseOrderInput,
  CreatePurchaseOrderInput,
  PurchaseOrderItemData,
  PurchaseOrdersPageData,
  PurchaseOrdersQuery,
  UpdatePurchaseOrderInput,
} from "../types/purchase-orders.types";


/* =========================================================
 * Query String
 * ======================================================= */

function buildQueryString(
  query: PurchaseOrdersQuery = {},
): string {
  const params =
    new URLSearchParams();


  if (query.search?.trim()) {
    params.set(
      "search",
      query.search.trim(),
    );
  }


  if (query.supplierId) {
    params.set(
      "supplierId",
      query.supplierId,
    );
  }


  if (query.warehouseId) {
    params.set(
      "warehouseId",
      query.warehouseId,
    );
  }


  if (query.currencyCode) {
    params.set(
      "currencyCode",
      query.currencyCode,
    );
  }


  if (query.status) {
    params.set(
      "status",
      query.status,
    );
  }


  if (query.fromDate) {
    params.set(
      "fromDate",
      query.fromDate,
    );
  }


  if (query.toDate) {
    params.set(
      "toDate",
      query.toDate,
    );
  }


  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }


  if (query.cursor) {
    params.set(
      "cursor",
      query.cursor,
    );
  }


  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(
        query.limit,
      ),
    );
  }


  const queryString =
    params.toString();


  return queryString
    ? `?${queryString}`
    : "";
}


/* =========================================================
 * Purchase Orders API
 * ======================================================= */

export const purchaseOrdersApi = {

  /**
   * GET /purchase-orders
   */
  list(
    query:
      PurchaseOrdersQuery = {},
  ) {
    return apiClient.get<
      PurchaseOrdersPageData
    >(
      `/purchase-orders${buildQueryString(
        query,
      )}`,
    );
  },


  /**
   * GET /purchase-orders/:purchaseOrderId
   */
  getById(
    purchaseOrderId: string,
  ) {
    return apiClient.get<
      PurchaseOrderItemData
    >(
      `/purchase-orders/${encodeURIComponent(
        purchaseOrderId,
      )}`,
    );
  },


  /**
   * POST /purchase-orders
   */
  create(
    input:
      CreatePurchaseOrderInput,
  ) {
    return apiClient.post<
      PurchaseOrderItemData
    >(
      "/purchase-orders",
      input,
    );
  },


  /**
   * PATCH /purchase-orders/:purchaseOrderId
   */
  update(
    purchaseOrderId: string,

    input:
      UpdatePurchaseOrderInput,
  ) {
    return apiClient.patch<
      PurchaseOrderItemData
    >(
      `/purchase-orders/${encodeURIComponent(
        purchaseOrderId,
      )}`,
      input,
    );
  },


  /**
   * POST /purchase-orders/:purchaseOrderId/approve
   */
  approve(
    purchaseOrderId: string,
  ) {
    return apiClient.post<
      PurchaseOrderItemData
    >(
      `/purchase-orders/${encodeURIComponent(
        purchaseOrderId,
      )}/approve`,
      {},
    );
  },


  /**
   * POST /purchase-orders/:purchaseOrderId/cancel
   */
  cancel(
    purchaseOrderId: string,

    input:
      CancelPurchaseOrderInput,
  ) {
    return apiClient.post<
      PurchaseOrderItemData
    >(
      `/purchase-orders/${encodeURIComponent(
        purchaseOrderId,
      )}/cancel`,
      input,
    );
  },
};
